import { AppConfig } from '@aipb/gulliver/env/util';
import { KeycloakManagerEnv } from './keycloak-manager.env';

export class KeycloakManagerConfig extends AppConfig<KeycloakManagerEnv> {
  get apiUrl(): string {
    return this.config.apiUrl;
  }

  get apiVersion(): string {
    return this.config.apiVersion || 'v1';
  }

  get rootGroup(): string {
    return this.config.rootGroup;
  }

  get enableDelete(): boolean {
    return this.config.enableDelete || false;
  }
}
